<template>
  <div class="columns margin-m50">
    <aside class="column is-2 aside hero is-fullheight">
      <div>
        <div class="main">
          <a class="item" :class="{'active': key == 'all'}" @click="reset()">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="is-size-6">كل الخدمات</span>
          </a>
          <a
            v-if="services != null"
            v-for="service in services"
            class="item"
            :class="{'active': key == service}"
            @click="filter(service)"
          >
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="is-size-6">{{service}}</span>
          </a>

          <!-- 
          <a class="item" :class="{'active': key == 'بطافة فيزا'}" @click="filter('بطافة فيزا')">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="has-text--bold">طلبات الفيزا</span>
          </a>

          <a class="item" :class="{'active': key == 'بطاقة تجوال'}" @click="filter('بطاقة تجوال')">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="has-text--bold">طلبات تجوال</span>
          </a>
          <a class="item" :class="{'active': key == 'مخصصات أسرتك'}" @click="filter('مخصصات أسرتك')">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="has-text--bold">طلبات مخصصات أرباب الأسر</span>
          </a>-->
          <!-- <a class="item" :class="{'active': key == 'مخصصات الشخصية '}" @click="filter('مخصصات الشخصية ')">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="has-text--bold">شراء عملة أجنبية للأغراض الشخصية</span>
          </a>-->
          <!-- <a class="item" :class="{'active': key == 'موبي كاش'}" @click="filter('موبي كاش')">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="has-text--bold">طلبات موبي كاش</span>
          </a>
           <a class="item" :class="{'active': key == 'إعادة مطالبة'}" @click="filter('إعادة مطالبة')">
            <span class="icon">
              <img class src="~/../assets/images/illustrations/icons/landing-v1/mobicash.png" alt>
            </span>
            <span class="has-text--bold">طلبات إعادة المطالبة</span>
          </a>-->
        </div>
      </div>
    </aside>
    <div id="message-feed" class="column is-10 messages hero is-fullheight">
      <div id="inbox-messages" class="inbox-messages">
        <div class="columns has-text-centered is-centered" v-if="loading">
          <loading
            line-fg-color="var(--primary-color)"
            size="massive"
            class="margin-100"
            text-fg-color="#2d3f51"
            message="الرجاء الإنتظار"
          />
        </div>

        <div v-else>
          <!-- Title -->

          <div class="columns is-centered mt-40">
            <div class="column">
              <!-- <b-table
            :data="isEmpty ? [] : requests"
                    :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :hoverable="isHoverable"
            :loading="isLoading"
            :focusable="isFocusable"
            :mobile-cards="hasMobileCards"
            
          >
            <template slot-scope="props">
              <b-table-column field="id" label="رقم" width="40" numeric>{{ props.row.id }}</b-table-column>
              <b-table-column field="name" label="الطلب"  >{{ props.row.name }}</b-table-column>
              <b-table-column field="Status" label="الحالة"  ><status :id=" props.row.Status"></status></b-table-column>
              <b-table-column field="createdAt" label="تاريخ الطلب"  >{{ props.row.createdAt }}</b-table-column>
              <b-table-column field="CompletedAt" label="تاريخ الانتهاء"  >{{ props.row.CompletedAt }}</b-table-column>
              <b-table-column field="Notes" label="ملاحظات" >{{ props.row.Notes }}</b-table-column>
              <b-table-column field="actions" label="نشاطات"  >   <button
                    class="button is-rounded is-dark is-shadowless"
                    @click="viewhistory(request.id)"
                  >
                    <b>عرض تفاصيل</b>
                  </button></b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                  </p>
                  <p>Nothing here.</p>
                </div>
              </section>
            </template>
              </b-table>-->
              <div class="table__wrapper" v-if="filteredrequests.length > 0">
                <table class="table is-striped mb-40 small-table is-narrow">
                  <thead>
                    <tr>
                      <th>رقم</th>
                      <th>الخدمة</th>
                      <th>الطلب</th>
                      <th>الحالة</th>
                      <th>تاريخ الطلب</th>
                      <th>تاريخ الانتهاء</th>
                      <th>ملاحظات</th>
                      <th>نشاطات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="request in filteredrequests" v-if="request.id != null">
                      <td>{{ request.id }}</td>
                      <td>{{ request.service }}</td>

                      <td>{{ request.ServicAction_Id}}</td>
                      <td>
                        <status :id="request.Status"></status>
                      </td>
                      <td>{{ request.createdAt.slice(0, 10) }}</td>

                      <td v-if="request.CompletedAt != null">{{ request.CompletedAt.slice(0, 10) }}</td>
                      <td v-else>-</td>

                      <td>{{ request.Notes }}</td>
                      <td>
                        <a
                          class="button is-rounded is-dark   is-shadowless is-small"
                          @click="viewhistory(request.id,request)"
                        >
                          <b>تفاصيل</b>
                        </a>
                        <a
                          v-if="request.Status == 1"
                          class="button is-rounded is-danger mr-5 is-small"
                          @click="cancel(request)"
                        >
                          <b>الغاء الطلب</b>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="margin-40" v-else>ليس لديك طلبات</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <history :id="requestid" :url="historyurl"></history>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { request } from "http";

export default {
  name: "Requestinboxdetailed",
  data() {
    return {
      loading: false,
      requests: null,
      services: null,
      filteredrequests: null,
      isComponentModalActive: false,
      isCancelComponentModalActive: false,
      requestid: null,
      historyurl: null,
      cancelurl: null,
      all: false,
      visa: false,
      zad: false,
      familyFCP: false,
      mobiCash: false,
      key: "all"
    };
  },
  created() {
    this.loading = true;
    var user = JSON.parse(localStorage.getItem("user"));

    axios.get("customer/requests/" + user[1]).then(response => {
      this.requests = response.data.results;
      this.filteredrequests = this.requests;
      this.loading = false;
      this.all = true;

      var lookup = {};
      var items = this.filteredrequests;
      this.services = [];

      for (var item, i = 0; (item = items[i++]); ) {
        var service = item.service;

        if (!(service in lookup)) {
          lookup[service] = 1;
          this.services.push(service);
        }
      }

    });
  },
  methods: {
    viewhistory(id, service) {
      this.historyurl = `/${service.serviceRoute}/getNotifiction/`
      this.requestid = id;
      this.isComponentModalActive = true;
    },
    reset() {
      this.key = "all";
      this.filteredrequests = this.requests;
    },
    filter(key) {
      this.reset();
      this.changekey(key);
      this.filteredrequests = this.filteredrequests.filter(function(obj) {
        return obj.service == key;
      });
    },
    changekey(key) {
      this.key = key;
      switch (key) {
        case "بطافة فيزا":
          this.historyurl = "/vs/getNotifiction/";
          break;
        case "بطاقة تجوال":
          this.historyurl = "/zad/getNotifiction/";
          break;
        case "مخصصات أسرتك":
          this.historyurl = "/familyfcp/getNotifiction/";
          break;
        case "الصحارى موبايل":
          this.historyurl = "/mobi/getNotifiction/";
          break;
        case "إعادة مطالبة - كروت الشحن":
          this.historyurl = "/refund/balanceCard/getNotifiction/";
          break;
        case "إعادة مطالبة - صراف آلي":
          this.historyurl = "/refund/atm/getNotifiction/";
          break;
        case "إعادة مطالبة - نقاط البيع":
          this.historyurl = "/refund/pos/getNotifiction/";
          break;
        case "إعادة مطالبة - موبي كاش":
          this.historyurl = "/refund/mobiCash/getNotifiction/";
          break;
      }
    },
    cancel(request) {
      this.cancelurl = `/${request.serviceRoute}/cancelRequest/`;
      this.$dialog.confirm({
        message: "هل انت متأكد من الغاء الطلب " + request.ServicAction_Id + " ذو الرقم " + request.id,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-danger",
        onConfirm: () =>
          this.$router.push({
            name: "cancelrequest",
            params: {
              requeststring: request.ServicAction_Id,
              requestid: request.id,
              requesturl: this.cancelurl
            }
          })
      });
    }
  }
};
</script>
